import store from "../store";
import * as types from "./constants";

export function openSlideshow(postId) {
  store.dispatch({
    type: types.TOGGLE_SLIDESHOW_VISIBLE,
    isOpen: true,
    postId
  });
  window.dataLayer.push({'event': 'view_photo_click'});
}
export function closeSlideshow() {
  store.dispatch({
    type: types.TOGGLE_SLIDESHOW_VISIBLE,
    isOpen: false,
    postId: 0,
    commentsVisible: false
  })
}
export function changeSlideshowSlide(postId, directionIsNext) {
  store.dispatch({
    type: types.CHANGE_SLIDE,
    postId
  });
  if (directionIsNext) {
    window.dataLayer.push({'event': 'next_photo_click'});
  } else {
    window.dataLayer.push({'event': 'previous_photo_click'});
  }
}
export function toggleSlideshowComments() {
  store.dispatch({
    type: types.TOGGLE_COMMENTS_VISIBLE
  })
}
export function hideSlideshowComments() {
  store.dispatch({
    type: types.SET_COMMENTS_VISIBLE,
    commentsVisible: false
  })
}
export function setSlideshowCommentPadding(commentPadding) {
  store.dispatch({
    type: types.SET_COMMENT_PADDING,
    commentPadding
  })
}

export function setOverlayAdVisible(visible) {
  store.dispatch({
    type: types.SET_OVERLAY_AD_VISIBLE,
    visible
  })
}



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/slideshow/actions.es6